import { addFilter } from '@wordpress/hooks';
import { useState, useEffect, RawHTML } from '@wordpress/element';
import { __ } from '@wordpress/i18n';

function FavoriteActivities() {
	const [ activities, setActivities ] = useState( [] );
	const [ loading, setLoading ] = useState( true );

	useEffect( () => {
		const { restUrl, nonce } = window.grandcoveDashboardFavorites || {};

		if ( ! restUrl || ! nonce ) {
			setLoading( false );
			return;
		}

		fetch( restUrl + 'grandcove/v1/favorite-activities', {
			headers: { 'X-WP-Nonce': nonce },
			credentials: 'same-origin',
		} )
			.then( ( res ) => res.json() )
			.then( ( data ) => {
				setActivities( Array.isArray( data ) ? data : [] );
			} )
			.catch( () => {
				setActivities( [] );
			} )
			.finally( () => {
				setLoading( false );
			} );
	}, [] );

	if ( loading ) {
		return <p>{ __( 'Loading favorites…', 'grandcove' ) }</p>;
	}

	if ( ! activities.length ) {
		return (
			<p className="grandcove-favorites-empty">
				{ __( 'You haven\'t favorited any activities yet. Browse activities and click the heart button to add favorites.', 'grandcove' ) }
			</p>
		);
	}

	return (
		<div className="grandcove-favorites-list">
			{ activities.map( ( activity ) => (
				<div key={ activity.id } className="grandcove-favorites-item">
					<h4 className="grandcove-favorites-item__title">
						{ activity.title }
					</h4>

					{ activity.upcoming_html && (
						<div className="grandcove-favorites-item__upcoming">
							<RawHTML>{ activity.upcoming_html }</RawHTML>
						</div>
					) }

					<a
						href={ activity.url }
						className="grandcove-favorites-item__link"
					>
						{ __( 'Go to this activity', 'grandcove' ) }
					</a>
				</div>
			) ) }
		</div>
	);
}

function RecentNews() {
	const [ posts, setPosts ] = useState( [] );
	const [ loading, setLoading ] = useState( true );

	useEffect( () => {
		const { restUrl, nonce } = window.grandcoveDashboardFavorites || {};

		if ( ! restUrl || ! nonce ) {
			setLoading( false );
			return;
		}

		fetch( restUrl + 'grandcove/v1/recent-news', {
			headers: { 'X-WP-Nonce': nonce },
			credentials: 'same-origin',
		} )
			.then( ( res ) => res.json() )
			.then( ( data ) => {
				setPosts( Array.isArray( data ) ? data : [] );
			} )
			.catch( () => {
				setPosts( [] );
			} )
			.finally( () => {
				setLoading( false );
			} );
	}, [] );

	if ( loading ) {
		return <p>{ __( 'Loading news…', 'grandcove' ) }</p>;
	}

	if ( ! posts.length ) {
		return (
			<p className="grandcove-news-empty">
				{ __( 'No recent news to display.', 'grandcove' ) }
			</p>
		);
	}

	return (
		<ul className="grandcove-news-list">
			{ posts.map( ( post ) => (
				<li key={ post.id } className="grandcove-news-item">
					<a href={ post.url } className="grandcove-news-item__title">
						{ post.title }
					</a>
					<span className="grandcove-news-item__date">
						{ post.date }
					</span>
				</li>
			) ) }
		</ul>
	);
}

addFilter(
	'athena_membership.dashboard_widgets',
	'grandcove/dashboard-widgets',
	( widgets ) => [
		{
			slug: 'favorite-activities',
			title: __( 'My Favorite Activities', 'grandcove' ),
			Component: FavoriteActivities,
			colSpan: 1,
		},
		{
			slug: 'recent-news',
			title: __( 'News', 'grandcove' ),
			Component: RecentNews,
			colSpan: 1,
		},
		...widgets,
	]
);
